export enum TrafficModel {
    BEST_GUESS = <any>"best_guess",
    PESSIMISTIC = <any>"pessimistic",
    OPTIMISTIC = <any>"optimistic"
}


// WEBPACK FOOTER //
// /Users/cwseger/go/src/github.com/cwseger/travel-time-ui/src/app/enums/traffic-model.enum.ts